<template>
  <main class="branded">
    <section class="cards">
      <embedded-video v-for="video in videos" :key="video.id" :video="video" />
    </section>
    <section class="lets-chat">
      <p>Like what you saw?</p>
      <ts-button
        title="LET'S CHAT"
        style="margin-top: 0"
        @click="$router.push('/contact')"
      />
    </section>
  </main>
</template>

<script>
import EmbeddedVideo from "@/components/EmbeddedVideo";
import TSButton from "@/components/TSButton";

export default {
  name: "Branded",
  components: {
    "embedded-video": EmbeddedVideo,
    "ts-button": TSButton,
  },
  data: function() {
    return {
      videos: [
        {
          id: 26,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/trimm_copenhagen_making_memories.jpg",
          description: "TRIMM Copenhagen | Making Memories Together",
          title: "TRIMM Copenhagen | Making Memories Together",
          link: "https://www.youtube.com/embed/uTmKLVaVl2k",
          size: { height: 900, width: 1600 },
          tags: ["Director", "Producer", "Editor"],
        },
        {
          id: 25,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/lego_foundation_bangladesh.jpg",
          description:
            "The LEGO Foundation | Building a world of play in Bangladesh",
          title: "The LEGO Foundation | Building a world of play in Bangladesh",
          link: "https://www.youtube.com/embed/Ij_LOz28HrY",
          size: { height: 900, width: 1600 },
          tags: ["Editor"],
        },
        {
          id: 24,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/danske_regioner_initiative_of_the_year.jpg",
          description: "Danske Regioner | Civic Initiative of the Year",
          title: "Danske Regioner | Civic Initiative of the Year",
          link: "https://www.youtube.com/embed/AxMjH_K0sWo",
          size: { height: 900, width: 1600 },
          tags: ["Director"],
        },
        {
          id: 23,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/Siemens_Episode1.jpg",
          description: "Siemens Two Creatives One Kitchen Episode 1",
          title: "Siemens | Two Creatives One Kitchen Ep. I",
          link: "https://www.youtube.com/embed/NiOTj8KjHwE",
          size: { height: 900, width: 1600 },
          tags: ["Director", "Producer", "Editor"],
        },
        {
          id: 22,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/Siemens_Episode2.jpg",
          description: "Siemens Two Creatives One Kitchen Episode 2",
          title: "Siemens | Two Creatives One Kitchen Ep. II",
          link: "https://www.youtube.com/embed/ENSmasiv4yY",
          size: { height: 900, width: 1600 },
          tags: ["Director", "Producer", "Editor"],
        },
        {
          id: 21,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/Siemens_Episode3.jpg",
          description: "Siemens Two Creatives One Kitchen Episode 3",
          title: "Siemens | Two Creatives One Kitchen Ep. III",
          link: "https://www.youtube.com/embed/yljd3tIRGlw",
          size: { height: 900, width: 1600 },
          tags: ["Director", "Producer", "Editor"],
        },
        {
          id: 20,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/Siemens_Episode4.jpg",
          description: "Siemens Two Creatives One Kitchen Episode 4",
          title: "Siemens | Two Creatives One Kitchen Ep. IV",
          link: "https://www.youtube.com/embed/bIwlAT23ZQE",
          size: { height: 900, width: 1600 },
          tags: ["Director", "Producer", "Editor"],
        },
        {
          id: 19,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/Vifor-Daniel.jpeg",
          description: "Vifor Pharma Heart Failure",
          title: "Vifor Pharma | Living with Heart Failure",
          link: "https://www.youtube.com/embed/j730IPVuEKs",
          size: { height: 900, width: 1600 },
          tags: ["Director", "Producer", "Editor"],
        },
        {
          id: 18,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/FSParkerXmas.png",
          description: "FS Parker Xmas",
          title: "FS Parker | It's Christmas!",
          link:
            "https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Ffsparker%2Fvideos%2F615092229247832%2F&show_text=0&wmode=opaque",
          size: { height: 900, width: 1600 },
          tags: ["Director", "Producer"],
        },
        {
          id: 17,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/Planzer_Tom_Luthi.jpeg",
          description: "Planzer Paket Tom Lüthi",
          title: "Planzer Paket | Passion for Precision",
          link: "https://www.youtube.com/embed/YMJjhk9kfNY",
          size: { height: 900, width: 1600 },
          tags: ["Director", "Producer", "Editor"],
        },
        {
          id: 16,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/siemens-studioline.jpeg",
          description: "Siemens StudioLine Lauch",
          title: "Siemens StudioLine | Product Launch",
          link: "https://www.youtube.com/embed/PPWS1D63whA",
          size: { height: 900, width: 1600 },
          tags: ["Editor"],
        },
        {
          id: 15,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/SMA.png",
          description: "Swiss Music Awards 2020",
          title: "Swiss Music Awards 2020 | Live TV Show Teaser",
          link: "https://www.youtube.com/embed/q9Iw-SURcIc",
          size: { height: 900, width: 1600 },
          tags: ["Editor"],
        },
        {
          id: 14,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/Vifor-Christine.jpeg",
          description: "Vifor Pharma Iron Deficiency",
          title: "Vifor Pharma | Facing Iron Deficiency",
          link: "https://www.youtube.com/embed/ljSI5nfPOTo",
          size: { height: 900, width: 1600 },
          tags: ["Director", "Producer", "Editor"],
        },
        {
          id: 13,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/SMA_event.png",
          description: "Swiss Music Awards Event",
          title: "Swiss Music Awards: 2020 Highlights",
          link: "https://www.youtube.com/embed/rbidk90HdFg",
          size: { height: 900, width: 1600 },
          tags: ["Director", "Producer", "Editor"],
        },
        {
          id: 12,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/SimmenGroup3.jpg",
          description: "SimmenGroup Double Check 3",
          title: "SimmenGroup DoubleCheck | Part |||",
          link: "https://www.youtube.com/embed/pl77N3wriZY?wmode=opaque",
          size: { height: 900, width: 1600 },
          tags: ["Director", "Producer", "Editor"],
        },
        {
          id: 11,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/SimmenGroup2.jpg",
          description: "SimmenGroup Double Check 2",
          title: "SimmenGroup DoublCheck | Part ||",
          link: "https://www.youtube.com/embed/k3cRXB79atA?wmode=opaque",
          size: { height: 900, width: 1600 },
          tags: ["Director", "Producer", "Editor"],
        },
        {
          id: 10,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/SimmenGroup1.jpg",
          description: "SimmenGroup Double Check 1",
          title: "SimmenGroup | DoubleCheck | Part |",
          link: "https://www.youtube.com/embed/a38V8ZAYAEg?wmode=opaque",
          size: { height: 900, width: 1600 },
          tags: ["Director", "Producer", "Editor"],
        },
        {
          id: 9,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/Aroma-Tram.png",
          description: "Aroma Ensemble",
          title: "Aroma | Ensemble Tram",
          link: "https://www.youtube.com/embed/Ibt77ERSXns",
          size: { height: 900, width: 1600 },
          tags: ["Director", "Producer", "Editor"],
        },
        {
          id: 8,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/Planzer_Camp.jpg",
          description: "Planzer Apprentice Camp",
          title: "Planzer | Apprentice camp",
          link: "https://www.youtube.com/embed/bjQXegJyn30",
          size: { height: 900, width: 1600 },
          tags: ["Director", "Producer", "Editor", "Videographer"],
        },
        {
          id: 7,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/Trojka.png",
          description: "Trojka Product",
          title: "Trojka | Product Montage",
          link: "https://www.youtube.com/embed/YDWIIR0GKT8",
          size: { height: 900, width: 1600 },
          tags: ["Editor"],
        },
        {
          id: 6,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/Planzer-Process.jpg",
          description: "Planzer Paket Process",
          title: "Planzer Paket | Low-Emission Parcel Delivery",
          link: "https://www.youtube.com/embed/YrLFELxgXm0",
          size: { height: 900, width: 1600 },
          tags: ["Producer", "Editor"],
        },
        {
          id: 5,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/Planzer_soap.jpeg",
          description: "Planzer Paket Soap Recycling",
          title: "Planzer Paket | Soap Recycling",
          link: "https://www.youtube.com/embed/LZjHNwkotSo",
          size: { height: 900, width: 1600 },
          tags: ["Director", "Producer", "Editor", "Videographer"],
        },
        {
          id: 4,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/Planzer-agentur.png",
          description: "Planzer Paket Agentur",
          title: "Planzer Paket | Easy as a Swipe",
          link: "https://www.youtube.com/embed/D1P9SckjfjY",
          size: { height: 900, width: 1600 },
          tags: ["Director", "Producer", "Editor"],
        },
        {
          id: 3,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/Planzer-apprenteice-01.jpg",
          description: "Planzer Transport Apprenticeship",
          title: "Planzer | Road Transport Apprenticeship",
          link: "https://www.youtube.com/embed/tqUT4p5UD64",
          size: { height: 900, width: 1600 },
          tags: ["Editor"],
        },
        {
          id: 2,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/Planzer-apprenteice-02.jpg",
          description: "Planzer Logistics Apprenticeship",
          title: "Planzer | Apprenticeship in Logistics",
          link: "https://www.youtube.com/embed/i98kVbKk2Bk?wmode=opaque",
          size: { height: 900, width: 1600 },
          tags: ["Editor"],
        },
        {
          id: 1,
          thumbnail:
            "https://storage.googleapis.com/signelarsenstatics/Planzer-apprenteice-03.jpg",
          description: "Planzer Merchant Apprenticeship",
          title: "Planzer | Merchant Apprenticeship",
          link: "https://www.youtube.com/embed/x4sYGp1JtCA?wmode=opaque",
          size: { height: 900, width: 1600 },
          tags: ["Editor"],
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.branded {
  display: grid;
  grid-template-columns: 1fr repeat(12, auto) 1fr;
  grid-gap: 40px;
  padding: 60px 0;
}
.cards {
  grid-column: 2 / span 12;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-gap: 40px;
}
.lets-chat {
  grid-column: 2 / span 12;
}
@media only screen and (max-width: 700px) {
  .branded {
    grid-gap: 20px;
  }
}
@media only screen and (max-width: 500px) {
  .branded {
    grid-template-columns: 10px repeat(6, 1fr) 10px;
    grid-gap: 10px;
  }
  .cards {
    grid-column: 2 / span 6;
    grid-template-columns: repeat(6, 1fr);
    grid-gap: 20px;
  }
}
</style>
